import * as React from "react"
import * as _ from "lodash"
import { connect } from "react-redux"
import { IAppointmentScheduleResponse } from "@curefit/care-common";
import LoginBoundary from "@curefit/pandora/dist/components/loginBoundary";
import IAccountData from "../models/IAccountData"
import AppUtils, { LOADING_STATE } from "../utils/AppUtils"
import { IAppState } from "../models/IAppState"
import { AccountDataActions } from "../actions/AccountDataActions"
import { DoctorProfileActions } from "../actions/DoctorProfileActions"
import ICenterInfo from "../models/ICenterInfo";
import { UserRoles, ModalSize, AppConstants, trackConfig, ORION_IMG_URL, RANGOON_PARAMS, FeatureConfigInfoKeySearchMap, ReferenceEntities, FeatureConfigValues } from "../utils/AppConstants";
import NewTwilioComponent from "../components/NewTwilioComponent";
import { AllStaticDataActions } from "../actions/AllStaticDataActions";
import { ToastNotification } from "../components/common/ToastNotification";
import GenericModal from "../components/GenericModal";
import IncompatibleBrowserModal from "../components/IncompatibleBrowserModal";
import NotificationPermissionModal from "../components/NotificationPermissionModal";
import TopNav from "../components/TopNav";
import IDoctorProfile from "../models/IDoctorProfile";
import ISearchDoctor from "../models/ISearchDoctor";
import IStaticDietRecallData from "../models/staticData/IStaticDietRecallData";
import ApiUtils from "../utils/ApiUtils";
import { Tracker } from "../utils/Tracker";

import { TwilioActions } from "../actions/TwilioActions";
import { EventNames } from "../utils/EventTrackerConstants";
import LocalStorageUtils from "../utils/LocalStorageUtils";
import { PushNotification } from "../PushNotification";
import { AlbusUrlConfigs } from "../api/AlbusUrlConfigs";
import { FeatureConfigInfoActions } from "../actions/FeatureConfigInfoActions";
import SelectDoctor from "../containers/AdminSelectDoctors";
import { PhoneCall } from "@curefit/care-rangoon-integration";
import { Detector, Online, Offline } from "react-detect-offline";
import {
    IFeatureConfigRequest,
    IFeatureConfigKeySearchMap,
    ISearchParam,
    IFeatureConfigResponse,
    IFeatureSectionConfig
} from "../models/IFeatureConfig";
import { InAppNotificationComponent } from "../components/InAppNotification";
import { RecoNotification } from "../components/RecoNotification";
import { IRecomTemplateWithPrescriptionData } from "../models/IRecoTemplates";
import { TreatmentPlanActions } from "../actions/TreatmentPlanActions";
import { RouteUtils, TREATMENT_PLANS } from "../routes";
import WhatsAppChatComponent from "../components/WhatsAppChatComponent";


if (navigator.serviceWorker) {
    navigator.serviceWorker.register("/orion-pwa-service-worker.js", { scope: "/" });  // registering pwa service worker.
}

export interface MainProps {
    doctorProfile: IDoctorProfile;
    allAppointments: IAppointmentScheduleResponse[];
    accountData: IAccountData;
    centerInfo: ICenterInfo;
    getAccountData: () => void;
    getDoctorProfile: (searchParams: ISearchDoctor) => void;
    getCenterRooms: (centerId: number) => void;
    getCenterDoctors: (centerId: number) => void;
    getAllStaticData: () => Promise<any>;
    staticDietRecallData: IStaticDietRecallData;
    setDoctorProfile: any;
    widgetData: any;
    modalHeaders: [];
    getFeatureConfigInfo: (params: IFeatureConfigRequest) => Promise<IFeatureConfigResponse>;
    setFeatureConfigInfo: (response: IFeatureConfigResponse) => void;
    getSectionAllowed: (doctorType: string, sectionKey: string) => Promise<any>;
    fetchRecomTemplates(doctorId: number, count: number, doctorType: string): Promise<IRecomTemplateWithPrescriptionData>;
}

export interface MainState {
    doctorProfileLoadingState: LOADING_STATE;
    dietRecallLoadingState: LOADING_STATE;
    isAdmin: boolean;
    showConnectionDetector: boolean;
    shouldSHowRecoNotifiaction: boolean
}

class Main extends React.Component<MainProps, MainState> {
    private internetPoll: any;
    private fetchedDoctorProfile: boolean = false;
    private recommendationPollInterval: NodeJS.Timeout;

    constructor(props: MainProps) {
        super(props);
        this.state = {
            ...this.getStateFromProps(this.props),
            showConnectionDetector: false,
            shouldSHowRecoNotifiaction: false
        };
    }

    componentDidMount() {
        setInterval(() => {
            let clickEvents = LocalStorageUtils.getItems("clickEvents");
            !_.isEmpty(clickEvents) && clickEvents.map((prop: any, index: number) => {
                Tracker.track(EventNames.Click, prop)
            })

            let getNewEvents = LocalStorageUtils.getItems("clickEvents"); // this is just a check to avoid concurrence of click events
            let newClickEvents = getNewEvents && getNewEvents.slice(clickEvents && clickEvents.length)
            LocalStorageUtils.setItem("clickEvents", newClickEvents);
        }, 60 * 1000);

        this.initialiseNwBandwidthInterval();

        this.props.getAllStaticData().then(() => {
            this.setState({
                dietRecallLoadingState: LOADING_STATE.LOADED
            })
        });
        this.internetPoll = setInterval(() => {
            ApiUtils.apiGetRequest(`${trackConfig.serviceUrl}${new Date().getTime()}`);
        }, AppConstants.DEFAULT_POLLING_INTERVAL_IN_SECONDS * 1000);
        window.addEventListener("online", () => {
            this.setState({
                showConnectionDetector: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showConnectionDetector: false
                    })
                }, 5000)
            })
        });

        window.addEventListener("offline", () => {
            this.setState({
                showConnectionDetector: true
            })
        });

    }

    checkForRecommendedTemplates = () => {
        if (this.props.doctorProfile) {
            setTimeout(() => {
                const { id, primarySubServiceType } = this.props.doctorProfile;
                this.props.fetchRecomTemplates(id, AppConstants.NUMBER_OF_RECOM_TEMPLATES_TO_FETCH, primarySubServiceType.code).then(recommendations => {
                    if (recommendations.prescriptions && recommendations.prescriptions.length > 0) {
                        this.setState({ shouldSHowRecoNotifiaction: true });
                    }
                }).catch(error => console.log(error));
            }, 2000);
        }
    }

    componentDidUpdate(prevProps: Readonly<MainProps>, prevState: Readonly<MainState>): void {
        if ((!prevProps.doctorProfile && this.props.doctorProfile) || prevProps.doctorProfile && this.props.doctorProfile && prevProps.doctorProfile.id !== this.props.doctorProfile.id) {
            Tracker.register({ doctorId: this.props.doctorProfile.id, speciality: this.props.doctorProfile.primarySubServiceType && this.props.doctorProfile.primarySubServiceType.displayValue })
            Tracker.track(EventNames.Login)
        }

        if ((!prevProps.accountData || !prevProps.accountData.id) || (this.props && this.props.accountData && prevProps && prevProps.accountData && this.props.accountData.id !== prevProps.accountData.id)) {
            if (this.props.accountData) {
                Tracker.identify(this.props.accountData.id.toString());
                Tracker.people.set({
                    $email: this.props.accountData.email,
                    $firstName: this.props.accountData.firstName,
                    $lastName: this.props.accountData.lastName,
                    $memberships: JSON.stringify(this.props.accountData.memberships)
                });
                Tracker.track(EventNames.Initial_load);
            }
        }
    }

    initialiseNwBandwidthInterval = () => {

        setInterval(() => {
            const consultationId = AppUtils.getConsultationIdFromOngoingUrl();
            if (consultationId) {
                Tracker.track(EventNames.Network_Speed, {
                    native: window.navigator && window.navigator.connection && window.navigator.connection.downlink,
                    consultationId,
                    doctorId: this.props.doctorProfile && this.props.doctorProfile.id
                });
            }
        }, 60 * 1000);
    }

    sectionAllowed = (subSectionPresent: IFeatureSectionConfig, doctorType: string): Promise<boolean> => {
        return new Promise((resolve, reject) => {
            if (!_.isEmpty(subSectionPresent)) {
                this.props.getSectionAllowed(doctorType, subSectionPresent.sectionKey)
                    .then((response: any) => {
                        if (response)
                            resolve(true);
                        else
                            resolve(false);
                    })
                    .catch(() => {
                        resolve(false);
                    })
            }
            else {
                resolve(true);
            }
        })
    }

    getStateFromProps = (currProps: MainProps) => {
        let doctorProfileLoadingState = LOADING_STATE.NOT_INITIALIZED;
        let dietRecallLoadingState = LOADING_STATE.NOT_INITIALIZED;
        let isAdmin: boolean = this.state ? this.state.isAdmin : false;

        if (!_.isEmpty(currProps.accountData)) {
            const roles = currProps.accountData.memberships;

            // TODO: Negate it
            const hasAdminRoles = !!roles.find(role => role.roleName === UserRoles.ADMIN);
            const hasDoctorRoles: boolean = !!roles.find(role => role.roleName === UserRoles.DOCTOR);

            if (hasAdminRoles && _.isEmpty(currProps.doctorProfile)) {
                isAdmin = true;
            } else if (hasDoctorRoles || hasAdminRoles) {
                if (!_.isEmpty(currProps.doctorProfile)) {
                    doctorProfileLoadingState = LOADING_STATE.LOADED;
                    if (!this.fetchedDoctorProfile) {
                        this.fetchedDoctorProfile = true; // setting the flag to avoid executing the following code multiple times

                        // Fetch Feature Configs
                        const params = {
                            [ReferenceEntities.DOCTOR]: currProps.doctorProfile.id
                        }

                        FeatureConfigInfoKeySearchMap.map((obj: IFeatureConfigKeySearchMap) => {
                            this.sectionAllowed(obj.subSectionPresent, currProps.doctorProfile.primarySubServiceType.code)
                                .then((response: boolean) => {
                                    if (response) {
                                        this.props.getFeatureConfigInfo({
                                            configName: obj.key,
                                            searchParams: obj.params.map((search: ReferenceEntities): ISearchParam => {
                                                return {
                                                    referenceEntity: search,
                                                    value: params[search]
                                                }
                                            })
                                        })
                                            .then((res: IFeatureConfigResponse) => {
                                                console.log(res);
                                                if (res.configName === "OrionEnablePrescriptionTemplate" && res.configValue === "TRUE") {
                                                    this.checkForRecommendedTemplates();
                                                }
                                            })
                                            .catch(console.log);
                                    }
                                    else {
                                        const configResponse: IFeatureConfigResponse = { configName: obj.key, configValue: FeatureConfigValues.FALSE }
                                        this.props.setFeatureConfigInfo(configResponse)
                                    }
                                })
                        })
                        // if (!this.state.isAdmin) {
                        //     ApiManager.getOllivanderServiceApis().fetchFeatueConfigInfo({
                        //         configName: "OrionEnableGcmNotification",
                        //         searchParams: [
                        //             {
                        //                 referenceEntity: ReferenceEntities.DOCTOR,
                        //                 value: params[ReferenceEntities.DOCTOR]
                        //             }
                        //         ]
                        //     }).then((response: IFeatureConfigResponse) => {
                        //         if (response && response.configValue === "TRUE" && "Notification" in window && Notification.permission !== "denied") {
                        //             const pnSaveUrl: string = AlbusUrlConfigs.getsavePushSubscriptionUrl(this.props.doctorProfile.id);
                        //             const pnBlockUrl: string = AlbusUrlConfigs.getBlockPushSubscriptionUrl(this.props.doctorProfile.id);
                        //             PushNotification.init(pnSaveUrl, pnBlockUrl, Notification.permission).catch((error: any) => {
                        //                 console.log(error)
                        //             });
                        //         }
                        //     })
                        // }

                    }
                }
                else {
                    const searchParams: ISearchDoctor = {
                        emailId: [AppUtils.getDoctorEmail(currProps.accountData)]
                    };
                    this.props.getDoctorProfile(searchParams)
                }
                // if (!_.isNull(currProps.staticDietRecallData)) dietRecallLoadingState = LOADING_STATE.LOADED
                // else this.props.getAllStaticData()
            } else {
                console.error("Unrecognized user role encountered");
                AppUtils.logout();
            }
        } else {
            this.props.getAccountData()
        }
        return {
            doctorProfileLoadingState: doctorProfileLoadingState,
            dietRecallLoadingState,
            isAdmin,
        }
    };

    componentWillReceiveProps(nextProps: MainProps) {
        this.setState(this.getStateFromProps(nextProps))
    }

    componentWillUnmount() {
        if (this.internetPoll) {
            clearInterval(this.internetPoll);
        }
    }

    navigateToTreatmentPlan = () => {
        RouteUtils.navigateToUrl(TREATMENT_PLANS);
        this.setState({ shouldSHowRecoNotifiaction: false });
        if (this.recommendationPollInterval) {
            clearInterval(this.recommendationPollInterval);
        }
    }

    dismissRecommendationMessageAndStopPoll = () => {
        this.setState({ shouldSHowRecoNotifiaction: false });
        if (this.recommendationPollInterval) {
            clearInterval(this.recommendationPollInterval);
        }
    }

    render() {
        const path = window.location.pathname || "/";
        let isLoading: boolean = (this.state.doctorProfileLoadingState !== LOADING_STATE.LOADED)
        // (this.state.doctorAppointmentsLoadingState !== LOADING_STATE.LOADED) ||
        // (this.state.dietRecallLoadingState !== LOADING_STATE.LOADED);

        const { isAdmin } = this.state;
        if (path.indexOf("/resume") > -1) {            // to bypass all the checks that are performed before routing and show only the login component when path is /resume
            return <div>{this.props.children}</div>
        }
        if (isAdmin && _.isEmpty(this.props.doctorProfile)) {
            return <SelectDoctor setDoctorProfile={this.props.setDoctorProfile} />
        }

        if (isLoading) {
            return (
                <div className="central-loader">
                    <img src={ORION_IMG_URL + "loader/curefit-loader.gif"} />
                </div>
            )
        }
        const isMobile: boolean = AppUtils.getIsMobile();
        return (
            <div>
                {/* {isMobile &&
                <LandScapeNotSupported />
            } */}
                <InAppNotificationComponent />
                <PhoneCall rangoonParams={RANGOON_PARAMS}></PhoneCall>
                {this.props.doctorProfile && (
                    <NewTwilioComponent
                        doctorId={
                            this.props.doctorProfile.id &&
                            this.props.doctorProfile.id.toString()
                        }
                    />
                )}
                <WhatsAppChatComponent />
                <TopNav />
                <ToastNotification />
                {this.state.shouldSHowRecoNotifiaction &&
                    <RecoNotification title="Frequent Diagnosis" ctaText="Check them out"
                        onCtaClick={this.navigateToTreatmentPlan} onCloseClick={this.dismissRecommendationMessageAndStopPoll}
                        message="We’ve noticed that some of the diagnosis are appearing more frequently" />
                }
                <GenericModal modalSize={ModalSize.XTRALARGE} keepPadding={true} />
                <div className="main-content-cont">
                    <Detector
                        render={(prop: any) => {
                            return (
                                <div
                                    className={`connection-detector ${this.state.showConnectionDetector ? "active" : ""
                                        } ${prop.online ? "online" : "offline"}`}
                                >
                                    {prop.online && (
                                        <span>
                                            Your computer is connected to internet again
                                            <br />
                          Please refresh docsapp before using it.
                                        </span>
                                    )}
                                    {!prop.online && (
                                        <span>Your computer lost its internet connection.</span>
                                    )}
                                </div>
                            );
                        }}
                    />
                    {this.props.children}
                </div>
                <IncompatibleBrowserModal />
                <NotificationPermissionModal isAdmin={this.state.isAdmin} doctorId={this.props.doctorProfile?.id} />
                <div>
                    <LoginBoundary />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: IAppState, ownProps: any): any {
    return Object.assign({}, {
        doctorProfile: state.doctorProfile,
        allAppointments: state.allAppointments,
        accountData: state.accountData,
        centerInfo: state.centerInfo,
        staticDietRecallData: state.allStaticDataNew.staticDietRecallData,
        router: ownProps.router
    });
}

function mapDispatchToProps(dispatch: any) {
    return {
        getAccountData: () => {
            return AccountDataActions.fetchAccountData(dispatch)
        },
        getDoctorProfile: (searchParams: ISearchDoctor) => {
            return DoctorProfileActions.fetchDoctorProfile(dispatch, searchParams)
        },
        setDoctorProfile: (doctorProfile: IDoctorProfile) => {
            return DoctorProfileActions.setDoctorProfile(dispatch, doctorProfile);
        },
        getAllStaticData: () => {
            return AllStaticDataActions.getAllConsolidatedStaticData(dispatch)
        },
        getFeatureConfigInfo: (params: IFeatureConfigRequest) => {
            return FeatureConfigInfoActions.fetchFeatureConfigInfo(dispatch, params)
        },
        setFeatureConfigInfo: (response: IFeatureConfigResponse) => {
            dispatch(FeatureConfigInfoActions.setFeatureConfigInfo(response))
        },
        getSectionAllowed: (doctorType: string, sectionKey: string): Promise<any> => {
            return FeatureConfigInfoActions.getSectionAllowed(doctorType, sectionKey)
        },
        fetchRecomTemplates: (doctorId: number, count: number, doctorType: string): Promise<IRecomTemplateWithPrescriptionData> => {
            return TreatmentPlanActions.fetchRecomTemplates(doctorId, count, doctorType);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main)
